import {
  Breadcrumbs,
  Link,
  Divider as MuiDivider,
  Typography,
  styled,
  Grid,
} from "@material-ui/core";
import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { NavLink } from "react-router-dom";
import PivotGrid from "../../components/PivotGrid";
import { spacing } from "@material-ui/system";
import useLocale from "../../hooks/useLocale";
import { useQuery } from "react-query";
import { fetchUserStatistics } from "../../services/userStatisticsService";
import YearSelect from "./YearSelect";
import MonthSelect from "./MonthSelect";
import dayjs from "dayjs";

const Divider = styled(MuiDivider)(spacing);

const UserStatistics = () => {
  const [month, setMonth] = useState(dayjs().month() + 1);
  const [year, setYear] = useState(dayjs().year());
  const { t } = useLocale();
  const { data: userStatistics, isLoading } = useQuery(
    ["userStatistics", month, year],
    fetchUserStatistics
  );

  return (
    <>
      <Helmet title={t("User statistics")} />
      <Typography variant="h3" gutterBottom display="inline">
        {t("User statistics")}
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Link component={NavLink} exact to="/">
          {t("Dashboard")}
        </Link>

        <Typography>{t("User statistics")}</Typography>
      </Breadcrumbs>
      <Divider my={6} />

      <Grid container spacing={5} style={{ marginBottom: 25 }}>
        <Grid item xs={3}>
          <YearSelect
            value={year}
            handleChange={(e) => setYear(e.target.value)}
          />
        </Grid>
        <Grid item xs={3}>
          <MonthSelect
            value={month}
            handleChange={(e) => setMonth(e.target.value)}
          />
        </Grid>
      </Grid>
      <PivotGrid data={userStatistics} isLoading={isLoading} />
    </>
  );
};

export default UserStatistics;
